// extracted by mini-css-extract-plugin
export default {"button":"BlackButton_button__9D2G0","button_primary":"BlackButton_button_primary__ILCBI","button_default":"BlackButton_button_default__Mjqtp"};